import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { TabeContainer, TabeCart, Container } from "./style";

import sessionAmount from "assets/images/session-amount.svg";
import termCondition from "assets/images/term & Conditions.svg";
import privacyPolicy from "assets/images/privacy-policy.svg";
import onBoarding from "assets/images/on-board.svg";
import dietary from "assets/images/dietary-choise.svg";
import faq from "assets/images/faq.svg";
import homeChiefOnboarding from "assets/images/hat-chef.png";
import signUpOnBoarding from "assets/images/sign-in-alt.png";
import precookingSetup from "assets/images/precooking-setup.svg";

import { setCMSActiveButton } from "store/user-slice";
import SessionAmount from "./session-amount";
import TermAndConditions from "./term-and-conditions";
import OnBoarding from "./onboarding";
import PrivacyPolicy from "./privacy-policy";
import DietaryChoise from "./dietary-choise";
import FAQ from "./faq";
import PrecookingSetup from "./precooking-setup";
import SessionPrerequisite from "./session-prerequisite";
import NoDataFound from "components/particles/no-data-found";
import { RootState } from "store";
import SessionCharges from "./session-charges";

export default function CMS() {
  const { CMSActiveButton, isLoading } = useSelector(
    (state: RootState) => state.user
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCMSActiveButton("Set Standard Session Amount"));
  }, []);

  return (
    <Container>
      <div className="title">
        <h1>CMS Settings</h1>
      </div>
      <TabeContainer>
        <TabeCart
          active={CMSActiveButton === "Set Standard Session Amount"}
          onClick={() => {
            dispatch(setCMSActiveButton("Set Standard Session Amount"));
          }}
        >
          <div className="categories-tab-img">
            <img src={sessionAmount} alt="img" width={30} />
          </div>
          <h1>Set Standard Session Amount</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "Session Charges"}
          onClick={() => {
            dispatch(setCMSActiveButton("Session Charges"));
          }}
        >
          <div className="categories-tab-img">
            <img src={sessionAmount} alt="img" width={30} />
          </div>
          <h1>Platform Charges</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "Terms & Conditions"}
          onClick={() => {
            dispatch(setCMSActiveButton("Terms & Conditions"));
          }}
        >
          <div className="categories-tab-img">
            <img src={termCondition} alt="img" width={30} />
          </div>
          <h1>Terms & Conditions</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "Privacy Policy"}
          onClick={() => {
            dispatch(setCMSActiveButton("Privacy Policy"));
          }}
        >
          <div className="categories-tab-img">
            <img src={privacyPolicy} alt="img" width={30} />
          </div>
          <h1>Privacy Policy</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "Dietary Choices"}
          onClick={() => {
            dispatch(setCMSActiveButton("Dietary Choices"));
          }}
        >
          <div className="categories-tab-img">
            <img src={dietary} alt="img" width={30} />
          </div>
          <h1>Dietary Choices</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "FAQ’s Management"}
          onClick={() => {
            dispatch(setCMSActiveButton("FAQ’s Management"));
          }}
        >
          <div className="categories-tab-img">
            <img src={faq} alt="img" width={30} />
          </div>
          <h1>FAQ’s Management</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "Onboarding Screen"}
          onClick={() => {
            dispatch(setCMSActiveButton("Onboarding Screen"));
          }}
        >
          <div className="categories-tab-img">
            <img src={onBoarding} alt="img" width={30} />
          </div>
          <h1>Onboarding Screen</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "SignUp Onboarding Screen"}
          onClick={() => {
            dispatch(setCMSActiveButton("SignUp Onboarding Screen"));
          }}
        >
          <div className="categories-tab-img">
            <img src={signUpOnBoarding} alt="img" width={30} />
          </div>
          <h1>SignUp Onboarding</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "HomeCook Onboarding Screen"}
          onClick={() => {
            dispatch(setCMSActiveButton("HomeCook Onboarding Screen"));
          }}
        >
          <div className="categories-tab-img">
            <img src={homeChiefOnboarding} alt="img" width={30} />
          </div>
          <h1>HomeCook Onboarding</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "Precooking Setup"}
          onClick={() => {
            dispatch(setCMSActiveButton("Precooking Setup"));
          }}
        >
          <div className="categories-tab-img">
            <img src={precookingSetup} alt="img" width={30} />
          </div>
          <h1>Precooking Setup</h1>
        </TabeCart>
        <TabeCart
          active={CMSActiveButton === "Session Prerequisite"}
          onClick={() => {
            dispatch(setCMSActiveButton("Session Prerequisite"));
          }}
        >
          <div className="categories-tab-img">
            <img src={termCondition} alt="img" width={30} />
          </div>
          <h1>Session Prerequisite</h1>
        </TabeCart>
      </TabeContainer>

      {CMSActiveButton === "HomeCook Onboarding Screen" ? (
        <OnBoarding type="HomeCook Onboarding Screen" />
      ) : CMSActiveButton === "SignUp Onboarding Screen" ? (
        <OnBoarding type="SignUp Onboarding Screen" />
      ) : CMSActiveButton === "Onboarding Screen" ? (
        <OnBoarding type="Onboarding Screen" />
      ) : CMSActiveButton === "Set Standard Session Amount" ? (
        <SessionAmount />
      ) : CMSActiveButton === "Terms & Conditions" ? (
        <TermAndConditions />
      ) : CMSActiveButton === "Privacy Policy" ? (
        <PrivacyPolicy />
      ) : CMSActiveButton === "Dietary Choices" ? (
        <DietaryChoise />
      ) : CMSActiveButton === "FAQ’s Management" ? (
        <FAQ />
      ) : CMSActiveButton === "Session Charges" ? (
        <SessionCharges />
      ) : CMSActiveButton === "Precooking Setup" ? (
        <PrecookingSetup />
      ) : CMSActiveButton === "Session Prerequisite" ? (
        <SessionPrerequisite />
      ) :
        <NoDataFound isShow={!isLoading} />
      }
    </Container>
  );
}
